import React from 'react'
import {Icon} from '@chakra-ui/react'
const LogoutIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M9 20H5C4.45 20 4 19.55 4 19V5C4 4.45 4.45 4 5 4H9C9.55 4 10 3.55 10 3C10 2.45 9.55 2 9 2H5C3.35 2 2 3.35 2 5V19C2 20.65 3.35 22 5 22H9C9.55 22 10 21.55 10 21C10 20.45 9.55 20 9 20Z"
                fill="currentColor"
            />
            <path
                d="M21.92 12.38C22.02 12.14 22.02 11.86 21.92 11.62C21.87 11.5 21.8 11.39 21.7 11.29L16.7 6.29C16.31 5.9 15.68 5.9 15.29 6.29C14.9 6.68 14.9 7.31 15.29 7.7L18.58 10.99H9C8.45 10.99 8 11.44 8 11.99C8 12.54 8.45 12.99 9 12.99H18.59L15.3 16.28C14.91 16.67 14.91 17.3 15.3 17.69C15.5 17.89 15.75 17.98 16.01 17.98C16.27 17.98 16.52 17.88 16.72 17.69L21.72 12.69C21.81 12.6 21.89 12.49 21.94 12.36L21.92 12.38Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default LogoutIcon
